import { render, staticRenderFns } from "./ConfigProdutoCaracteristicas.vue?vue&type=template&id=287a8565"
import script from "./ConfigProdutoCaracteristicas.vue?vue&type=script&lang=js"
export * from "./ConfigProdutoCaracteristicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports